import { Button } from '@mui/material';
import { LoadingButton } from '@ankr.com/ui';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { buttonsTranslation } from './translation';
import { useButtonsStyles } from './useButtonsStyles';

export interface IButtonsProps {
  isSignInButtonLoading: boolean;
  onCancelButtonClick: () => void;
  onSignInButtonClick: () => void;
}

export const Buttons = ({
  isSignInButtonLoading,
  onCancelButtonClick,
  onSignInButtonClick,
}: IButtonsProps) => {
  const { keys, t } = useTranslation(buttonsTranslation);

  const { classes } = useButtonsStyles();

  return (
    <div className={classes.root}>
      <LoadingButton
        color="primary"
        loading={isSignInButtonLoading}
        onClick={onSignInButtonClick}
        size="large"
        variant="contained"
      >
        {t(keys.signInButton)}
      </LoadingButton>
      <Button
        color="primary"
        onClick={onCancelButtonClick}
        size="large"
        variant="outlined"
      >
        {t(keys.cancelButton)}
      </Button>
    </div>
  );
};
